export default __webpack_public_path__ + "static/l5-about-sm-1e150cace19b1c8011fef061ccb7c9d4.jpg";